export default function UserArmiesChange(armies) {
  return { type: 'User_Armies_Change', payload: armies };
}
